import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'msConvert',
})
export class MsConvertPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  convertMS(milliseconds: number) {
    let day, hour, minute, seconds;
    seconds = Math.floor(milliseconds / 1000);
    minute = Math.floor(seconds / 60);
    seconds = seconds % 60;
    hour = Math.floor(minute / 60);
    minute = minute % 60;
    day = Math.floor(hour / 24);
    hour = hour % 24;
    let DAY, HR, MIN, SEC;

    [DAY, HR, MIN, SEC] = [
      'PIPES.MS_CONVERT_PIPE.DAY',
      'PIPES.MS_CONVERT_PIPE.HR',
      'PIPES.MS_CONVERT_PIPE.MIN',
      'PIPES.MS_CONVERT_PIPE.SEC',
    ];

    const translations = this.translateService.instant([DAY, HR, MIN, SEC]);

    return {
      [translations[DAY]]: day,
      [translations[HR]]: hour,
      [translations[MIN]]: minute,
      [translations[SEC]]: seconds,
    };
  }

  transform(value: number, test = null): unknown {
    const time = this.convertMS(value);

    let formattedTime = '';

    Object.keys(time).forEach((key) => {
      if (time[key]) {
        formattedTime =
          time[key] === 1
            ? formattedTime.concat(`${time[key]} ${key} `)
            : formattedTime.concat(`${time[key]} ${key}s `);
      }
    });

    return formattedTime;
  }
}
